import styled from '@emotion/styled'

export const BulletUnorderedList = styled.ul`
  list-style: disc;
  margin-left: 1.5rem;
`
